module.exports = __webpack_public_path__ + "static/img/rank_3.bf2bff7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_3.png
// module id = 5cFv
// module chunks = 0